import {environment} from '../../environments/environment';

console.log(environment);
export const Config = {
  'api': environment.API_URL
};
